import { useEffect } from "react";
import HeaderStyleTwo from "../Shared/HeaderStyleTwo";
import Footer from "../Shared/Footer";
import VolunteersBanner from "../Shared/VolunteersBanner";
const OurTeam = () => {
    useEffect(() => {
        runJQueryScripts();
    }, []);

    const runJQueryScripts = () => {
        let tag: any;
        let loadScript = function (src: string) {
            tag = document.createElement("script");
            tag.async = false;
            tag.src = src;
            document.getElementsByTagName("body")[0].appendChild(tag);
        };
        loadScript("../assets/js/jquery.js");
        loadScript("../assets/js/popper.min.js");
        loadScript("../assets/js/jquery-ui.js");
        loadScript("../assets/js/jquery.fancybox.js");
        loadScript("../assets/js/owl.js");
        loadScript("../assets/js/appear.js");
        loadScript("../assets/js/wow.js");
        loadScript("../assets/js/lazyload.js");
        loadScript("../assets/js/scrollbar.js");
        loadScript("../assets/js/script.js");
        return () => {
            document.getElementsByTagName("body")[0].removeChild(tag);
        }
    }
    return (
        <>
            <HeaderStyleTwo />
            {/* <section className="page-banner">
                <div className="image-layer lazy-image" data-bg="url('assets/images/background/bg-banner-1.jpg')"></div>
                <div className="bottom-rotten-curve alternate"></div>
                <div className="auto-container">
                    <h1>About Us</h1>
                    <ul className="bread-crumb clearfix">
                        <li><a href="/">Home</a></li>
                        <li className="active">About Us</li>
                    </ul>
                </div>
            </section> */}
            <div className="ulockd-inner-page">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="ulockd-icd-layer">
                                <ul className="list-inline ulockd-icd-sub-menu">
                                    <li><a style={{ color: '#25283a' }} href="/"> Home </a></li>
                                    <li><a style={{ color: '#25283a' }} href="#"><b> / </b></a></li>
                                    <li> <a href="/our-team">Our Team </a> </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section className="team-section" style={{padding: '50px 0px 0px'}}>
                {/* <div className="bottom-rotten-curve"></div> */}
                <div className="auto-container">
                    <div className="row clearfix">
                        <div className="team-block col-xl-4 col-lg-4 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInUp" data-wow-delay="0ms">
                                <figure className="image-box"><a href="/founder-message"><img className="lazy-image" src="assets/images/resource/image-spacer-for-validation.png" data-src="assets/images/resource/dr-shoaib-siddiqu-founder-sadqa-e-jariya-welfare-foundation.jpg" alt="" /></a></figure>
                                <div className="lower-box">
                                    <div className="content">
                                        <h3><a href="/founder-message">Dr. Shoaib A Siddiqui</a></h3>
                                        <div className="designation">Founder - Volunteer</div>
                                        <p>Infectious Disease Specialist in Kissimmee, Florida</p>
                                        <div className="social-links">
                                            <ul className="clearfix">
                                                <li><a href="#"><span className="fab fa-facebook-f"></span></a></li>
                                                <li><a href="#"><span className="fab fa-twitter"></span></a></li>
                                                <li><a href="#"><span className="fab fa-linkedin-in"></span></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="team-block col-xl-4 col-lg-4 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInUp" data-wow-delay="0ms">
                                <figure className="image-box"><a href="#"><img className="lazy-image" src="assets/images/resource/image-spacer-for-validation.png" data-src="assets/images/resource/omer-wajahat.jpg" alt="" /></a></figure>
                                <div className="lower-box">
                                    <div className="content">
                                        <h3><a href="#">Mr. Omer Wajahat</a></h3>
                                        <div className="designation">Managing Director - Volunteer</div>
                                        {/* <p>Infectious Disease Specialist in Kissimmee, Florida</p> */}
                                        <div className="social-links">
                                            <ul className="clearfix">
                                                <li><a href="#"><span className="fab fa-facebook-f"></span></a></li>
                                                <li><a href="#"><span className="fab fa-twitter"></span></a></li>
                                                <li><a href="#"><span className="fab fa-linkedin-in"></span></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="team-block col-xl-4 col-lg-4 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInUp" data-wow-delay="0ms">
                                <figure className="image-box"><a href="#"><img className="lazy-image" src="assets/images/resource/image-spacer-for-validation.png" data-src="assets/images/resource/engr-saquib-altaf-sadqa-e-jariya-welfare-foundation.jpg" alt="" /></a></figure>
                                <div className="lower-box">
                                    <div className="content">
                                        <h3><a href="#">Engr. Saqib Altaf</a></h3>
                                        <div className="designation">IT Director - Volunteer</div>
                                        {/* <p>Infectious Disease Specialist in Kissimmee, Florida</p> */}
                                        <div className="social-links">
                                            <ul className="clearfix">
                                                <li><a href="#"><span className="fab fa-facebook-f"></span></a></li>
                                                <li><a href="#"><span className="fab fa-twitter"></span></a></li>
                                                <li><a href="#"><span className="fab fa-linkedin-in"></span></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
            <VolunteersBanner />
            <Footer />
        </>
    );
};
export default OurTeam;
